import {
    Box,
    FormControl,
    Grid,
    Typography,
    Select,
    MenuItem,
} from "@mui/material";
import OutlinedInput from "@mui/material/OutlinedInput";
import React from "react";
import TextField from "@mui/material/TextField";
import { grey } from "@mui/material/colors";
import { useEffect, useState } from 'react';

import useTypeItems from '../../hook/TypeItems';
import useCustomerItems from '../../hook/CustomerItems';
import useShopItems from '../../hook/ShopItems';
  
export const Content = ({ saveCondition, setSaveCondition, errors, validateData }) => {
  const [filteredShops, setFilteredShops] = useState([]);
  const typeList = useTypeItems();
  const customerList = useCustomerItems();
  const shopList = useShopItems();

  useEffect(() => {
    if (saveCondition.customer) {
      const initialShops = shopList.filter(shop => shop.customerId === saveCondition.customer);
      setFilteredShops(initialShops);
      
      if (initialShops.length === 1) {
        setSaveCondition(prev => ({ ...prev, shop: initialShops[0].shopId }));
      }
    }
  }, [shopList, saveCondition.customer]);

  const handleChengeLoginId = async(e) => {
    const newLoginId = e.target.value;
    setSaveCondition({...saveCondition, loginId: newLoginId})
    await validateData({ ...saveCondition, loginId: newLoginId }, 'loginId');
  }

  const handleChengePassword = async (e) => {
    const newPassword = e.target.value;
    setSaveCondition({...saveCondition, password: newPassword});
    await validateData({ ...saveCondition, password: newPassword }, 'password');
  };

  const handleChengePassAgain = async (e) => {
    const newPassAgain = e.target.value;
    setSaveCondition({...saveCondition, passAgain: newPassAgain});
    await validateData({ ...saveCondition, passAgain: newPassAgain }, 'passAgain');
  };

  const handleChengeName = async(e) => {
    const newName = e.target.value;
    setSaveCondition({...saveCondition, name: newName})
    await validateData({ ...saveCondition, name: newName }, 'name');
  }

  const handleChengeKana = (e) => {
    setSaveCondition({...saveCondition, kana: e.target.value})
  }
    
  const handleChengeType = async(e) => {
    const newType = e.target.value === "not" ? null : parseInt(e.target.value);
    setSaveCondition({...saveCondition, type: newType, customer: null, shop: null })
    await validateData({ ...saveCondition, type: newType }, 'type');
  }

  const handleFocusType = async() => {
    await validateData({ ...saveCondition }, 'type');
    if (saveCondition.type !== 2) {
      await validateData({ ...saveCondition }, 'customer');
      await validateData({ ...saveCondition }, 'shop');
    }
  }

  const handleChengeCustomer = async(e) => {
    const newCustomer = e.target.value === "not" ? null : parseInt(e.target.value);
    const newFilteredShops = shopList.filter(shop => shop.customerId === newCustomer);
    setFilteredShops(newFilteredShops);
    if (newFilteredShops.length === 1) {
      setSaveCondition(prev => ({ ...prev, customer: newCustomer, shop: newFilteredShops[0].shopId }));
    } else {
      setSaveCondition({...saveCondition, customer: newCustomer, shop: null})
    }
    await validateData({ ...saveCondition, customer: newCustomer }, 'customer');
  }

  const handleFocusCustomer = async() => {
    await validateData({ ...saveCondition }, 'customer');
    if (filteredShops.length <= 1) {
      await validateData({ ...saveCondition }, 'shop');
    }
  }

  const handleChengeShop = async(e) => {
    const newShop = e.target.value === "not" ? null : parseInt(e.target.value);
    setSaveCondition({ ...saveCondition, shop: newShop });
    await validateData({ ...saveCondition, shop: newShop }, 'shop');
  }

  const handleFocusShop = async() => {
    await validateData({ ...saveCondition }, 'shop');
  }
    
  const handleChengeNote = (e) => {
    setSaveCondition({...saveCondition, note: e.target.value})
  }

  return (
      <Box margin={2}>
        <Grid container alignItems="center">
          <Grid item xs="auto">
            ログインID
          </Grid>
          <Grid item sx>
            <Typography color="error">
              (必須)
            </Typography>
            <Box sx={{ width: 110 }} />
          </Grid>
          
          <Grid item sx>
            <OutlinedInput
              sx={{ width: 300 }}
              value={saveCondition.loginId}
              onChange={handleChengeLoginId}
              onBlur={handleChengeLoginId}
              error={errors.loginId}
              autoComplete="new-loginId"
            />
          </Grid>
        </Grid>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          {errors.loginId && (
            <>
              <Box sx={{ width: 190 }} />
              <Typography color="error" variant="caption">
                {errors.loginId}
              </Typography>
            </>
          )}
        </Box>
        
        <Box height={5} />
        <Box sx={{ borderBottom: `0.5px solid ${grey[300]}`, my: 1 }} />
        <Box height={5} />

        <Grid container alignItems="center">
          <Grid item xs="auto">
            パスワード
          </Grid>
          <Grid item sx>
            <Typography color="error">
              (必須)
            </Typography>
            <Box sx={{ width: 110 }} />
          </Grid>

          <Grid item sx>
            <OutlinedInput
              sx={{ width: 300 }}
              type="password"
              value={saveCondition.password}
              onChange={handleChengePassword}
              onBlur={handleChengePassword}
              error={errors.password}
              autoComplete="new-password"
            />
          </Grid>
        </Grid>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          {errors.password && (
            <>
              <Box sx={{ width: 190 }} />
              <Typography color="error" variant="caption">
                {errors.password}
              </Typography>
            </>
          )}
        </Box>

        <Box height={5} />
        <Box sx={{ borderBottom: `0.5px solid ${grey[300]}`, my: 1 }} />
        <Box height={5} />

        <Grid container alignItems="center">
          <Grid item xs="auto">
            確認用パスワード
          </Grid>
          <Grid item sx>
            <Typography color="error">
              (必須)
            </Typography>
            <Box sx={{ width: 62 }} />
          </Grid>

          <Grid item sx>
            <OutlinedInput
              sx={{ width: 300 }}
              type="password"
              value={saveCondition.passAgain}
              onChange={handleChengePassAgain}
              onBlur={handleChengePassAgain}
              error={errors.passAgain}
              autoComplete="new-passAgain"
            />
          </Grid>
        </Grid>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          {errors.passAgain && (
            <>
              <Box sx={{ width: 190 }} />
              <Typography color="error" variant="caption">
                {errors.passAgain}
              </Typography>
            </>
          )}
        </Box>

        <Box height={5} />
        <Box sx={{ borderBottom: `0.5px solid ${grey[300]}`, my: 1 }} />
        <Box height={5} />

        <Grid container alignItems="center">
          <Grid item xs="auto">
            氏名
          </Grid>
          <Grid item sx>
            <Typography color="error">
              (必須)
            </Typography>
            <Box sx={{ width: 159 }} />
          </Grid>

          <Grid item sx>
            <OutlinedInput
              sx={{ width: 300 }}
              value={saveCondition.name}
              onChange={handleChengeName}
              onBlur={handleChengeName}
              error={errors.name}
            />
          </Grid>
        </Grid>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          {errors.name && (
            <>
              <Box sx={{ width: 190 }} />
              <Typography color="error" variant="caption">
                {errors.name}
              </Typography>
            </>
          )}
        </Box>

        <Box height={5} />
        <Box sx={{ borderBottom: `0.5px solid ${grey[300]}`, my: 1 }} />
        <Box height={5} />

        <Grid container alignItems="center">
          <Grid item xs="auto">
            フリガナ
          </Grid>
          <Grid item sx>
            <Box sx={{ width: 127 }} />
          </Grid>

          <Grid item sx>
            <OutlinedInput
              sx={{ width: 300 }}
              value={saveCondition.kana}
              onChange={handleChengeKana}
            />
          </Grid>
        </Grid>

        <Box height={5} />
        <Box sx={{ borderBottom: `0.5px solid ${grey[300]}`, my: 1 }} />
        <Box height={5} />
  
        <Grid container alignItems="center">
            <Grid item xs="auto">
              種別
            </Grid>
            <Grid item sx>
              <Typography color="error">
                (必須)
              </Typography>
              <Box sx={{ width: 160 }} />
            </Grid>

          <Grid item>
            <FormControl sx={{ width: 100 }}>
              <Select
                labelId="type-select"
                value={saveCondition.type === null ? "not" : String(saveCondition.type)}
                onChange={handleChengeType}
                onFocus={handleFocusType}
                error={errors.type}
              >
                <MenuItem value="not">未選択</MenuItem>
                {typeList.map((type) => (
                  <MenuItem key={type.value} value={type.value}>
                    {type.type}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          
          <Grid item>
            <Box width={70} />
          </Grid>

          <Grid item>
            取引先
          </Grid>
          <Grid item sx>
            <Box sx={{ width: 20 }} />
          </Grid>
          
          <Grid item>
            <FormControl sx={{ width: 200 }}>
              <Select
                labelId="customer-select"
                value={saveCondition.type !== 2 ? "not" : (saveCondition.customer ? String(saveCondition.customer) : "not")}
                onChange={handleChengeCustomer}
                onFocus={handleFocusCustomer}
                disabled={saveCondition.type !== 2}
                error={errors.customer}
              >
                <MenuItem value="not">未選択</MenuItem>
                {customerList.map((customer) => (
                  <MenuItem key={customer.value} value={customer.value}>
                    {customer.customer}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item>
            <Box width={70} />
          </Grid>
          
          <Grid item>
            店舗
          </Grid>
          <Grid item sx>
            <Box sx={{ width:20 }} />
          </Grid>

          <Grid item>
            <FormControl sx={{ width: 135 }}>
              <Select
                labelId="shop-select"
                value={saveCondition.customer === null ? "not" : (saveCondition.shop ? String(saveCondition.shop) : "not")}
                onChange={handleChengeShop}
                onFocus={handleFocusShop}
                disabled={saveCondition.customer === null}
                error={errors.shop}
              >
                {filteredShops.length !== 1 && (
                  <MenuItem value="not">未選択</MenuItem>
                )}
                {filteredShops
                  .map((shop) => (
                    <MenuItem key={shop.shopId} value={shop.shopId}>
                      {shop.shop.trim() === "" ? "本店" : shop.shop}
                    </MenuItem>
                  ))
                }
              </Select>
            </FormControl>
          </Grid>
        </Grid>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          {errors.type && (
            <Box sx={{ width: 225, marginLeft: 23.9 }}>
              <Typography color="error" variant="caption">
                {errors.type}
              </Typography>
            </Box>
          )}
  
          {errors.customer && (
            <Box sx={{ width: 225, marginLeft: 53.9 }}>
              <Typography color="error" variant="caption">
                {errors.customer}
              </Typography>
            </Box>
          )}
  
          {errors.shop && (
            <Box sx={{ width: 225, marginLeft: 94.2 }}>
              <Typography color="error" variant="caption">
                {errors.shop}
              </Typography>
            </Box>
          )}
        </Box>


        <Box height={5} />
        <Box sx={{ borderBottom: `0.5px solid ${grey[300]}`, my: 1 }} />
        <Box height={5} />

        <Grid container alignItems="center" spacing={2}>
          <Grid item xs="auto">
            備考
          </Grid>
          <Grid item sx>
            <Box sx={{ width: 127 }} />
          </Grid>

          <Grid item sx>
            <TextField
              sx={{ width: 700 }}
              value={saveCondition.note}
              onChange={handleChengeNote}
              multiline
              rows={3}
              variant="outlined"
            />
          </Grid>
        </Grid>
      </Box>
  );
}